





















import Vue from "vue";

// Model
import { Machine } from "@/model/data/Machine";
import { CashTypeEnum, cashTypeEnumLabel } from "@/model/data/enums/CashTypeEnum";

export default Vue.extend({
    data() {
        return {
            CashTypeEnum,
        };
    },
    props: {
        machine: { type: Object as () => Machine, required: true },
    },
    methods: { cashTypeEnumLabel },
});
